import { render } from "./randomTxt.vue?vue&type=template&id=a704b41e"
import script from "./randomTxt.vue?vue&type=script&lang=js"
export * from "./randomTxt.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__